import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

export const Icon = props => {
  const { name, className, width, height, color } = props;
  let content = null;

  if (name === 'correct') {
    content = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || 15}
        height={height || 15}
      >
        <path
          fill="#4CBC56"
          fillRule="evenodd"
          d="M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0z"
        />
        <path
          fill="none"
          stroke="#FFF"
          strokeWidth="2"
          d="M10.293 4.693L6.287 8.62l-2.58-2.529"
        />
      </svg>
    );
  } else if (name === 'incorrect') {
    content = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || 15}
        height={height || 15}
      >
        <path
          fill="#FF2601"
          fillRule="evenodd"
          d="M7 0a7 7 0 1 1 0 14A7 7 0 0 1 7 0z"
        />
        <path
          fill="none"
          stroke="#FFF"
          strokeWidth="2"
          d="M3.745 10.254l6.499-6.498M3.716 3.723l6.561 6.561"
        />
      </svg>
    );
  } else if (name === 'time') {
    content = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || 27}
        height={height || 27}
      >
        <path
          fill="none"
          stroke={color || '#424242'}
          strokeWidth="2"
          d="M13 1c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12C1 6.372 6.372 1 13 1z"
        />
        <path
          fill="none"
          stroke={color || '#424242'}
          strokeWidth="2"
          d="M13 8v5h6"
        />
      </svg>
    );
  } else if (name === 'questions') {
    content = (
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="27">
        <path
          fill="none"
          fillRule="evenodd"
          stroke="#424242"
          strokeWidth="2"
          d="M4 5.988h14a2 2 0 0 1 2 2v14.023a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7.988a2 2 0 0 1 2-2zM6 13h10M6 18h10"
        />
        <path
          fill="#FFF"
          fillRule="evenodd"
          stroke="#424242"
          strokeWidth="2"
          d="M15 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h1.183A2.993 2.993 0 0 1 11 2a2.99 2.99 0 0 1 2.816 2H15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1z"
        />
      </svg>
    );
  } else if (name === 'start') {
    content = (
      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="19">
        <path
          fill="none"
          stroke="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M2.027 2.018L11.989 9l-9.962 6.981V2.018z"
        />
      </svg>
    );
  } else if (name === 'logout') {
    content = (
      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19">
        <path
          fill="none"
          stroke="#FF2601"
          strokeWidth="2"
          d="M12.471 2.864a7.032 7.032 0 0 1 3.531 6.106c0 3.882-3.135 7.029-7.002 7.029S1.998 12.852 1.998 8.97a7.032 7.032 0 0 1 3.578-6.133"
        />
        <path
          fill="none"
          stroke="#FF2601"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M9 1.014v6.998"
        />
      </svg>
    );
  } else if (name === 'close') {
    content = (
      <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17">
        <path
          fill="none"
          stroke={color || '#FF2601'}
          strokeWidth="2"
          d="M1.764 14.235L14.287 1.712M1.707 1.699L14.3 14.293"
        />
      </svg>
    );
  } else if (name === 'arrow-left') {
    content = (
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="19">
        <path
          fill="none"
          stroke="#424242"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M9.983 15.988L2.007 8.995l7.976-6.992"
        />
      </svg>
    );
  } else if (name === 'arrow-right') {
    content = (
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="19">
        <path
          fill="none"
          stroke="#424242"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M2.016 2.012l7.977 6.993-7.977 6.993"
        />
      </svg>
    );
  } else if (name === 'done') {
    content = (
      <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14">
        <path
          fill="none"
          fillRule="evenodd"
          stroke="#4CBC56"
          strokeWidth="2"
          d="M16.291 1.725l-8.87 8.855-5.713-5.702"
        />
      </svg>
    );
  } else if (name === 'logo') {
    content = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || 120}
        height={height || 20}
        viewBox="0 0 120 20"
      >
        <path
          fill={color || '#424242'}
          fillRule="evenodd"
          d="M69.79 6.919v9.266h-3.02V6.919h-3.882V3.984h3.882V0h3.02v3.984h5.214v2.935H69.79zm-15.676.299c-.206.199-.31.491-.31.874v8.093h-2.986V8.092c0-.504.065-.955.195-1.354a3.88 3.88 0 0 1 .523-1.055c.218-.305.469-.565.752-.779a4.442 4.442 0 0 1 1.832-.824c.318-.064.614-.096.89-.096h6.741v2.935h-6.718c-.406 0-.712.099-.919.299zm-6.477 7.268a3.442 3.442 0 0 1-.747.779 4.341 4.341 0 0 1-.89.525 4.669 4.669 0 0 1-1.843.395h-5.386c-.413 0-.865-.071-1.355-.215a4.013 4.013 0 0 1-1.361-.705 3.962 3.962 0 0 1-1.045-1.275c-.279-.523-.419-1.165-.419-1.925V8.092c0-.752.14-1.39.419-1.913a3.962 3.962 0 0 1 1.045-1.275 4.013 4.013 0 0 1 1.361-.705c.49-.143.942-.215 1.355-.215h5.386c.766 0 1.417.136 1.953.406a3.87 3.87 0 0 1 1.297 1.022c.33.41.569.856.718 1.337.149.482.224.93.224 1.343v3.973c0 .504-.065.958-.195 1.36-.13.403-.303.756-.517 1.061zm-2.274-6.371c0-.406-.103-.707-.31-.903-.207-.196-.505-.293-.896-.293h-5.363c-.398 0-.701.099-.907.299-.207.199-.31.491-.31.874v3.973c0 .384.103.677.31.881.206.203.509.304.907.304h5.363c.406 0 .708-.101.907-.304.2-.204.299-.497.299-.881v-3.95zm-13.781 6.371a3.463 3.463 0 0 1-.747.779 4.341 4.341 0 0 1-.89.525 4.686 4.686 0 0 1-1.831.395h-5.387V13.25h5.387c.398 0 .696-.101.895-.304.199-.204.299-.497.299-.881v-3.95c0-.406-.101-.707-.304-.903-.203-.196-.5-.293-.89-.293H22.75c-.406 0-.712.099-.918.299-.207.199-.31.491-.31.874V20h-2.986V8.092c0-.504.065-.955.195-1.354.13-.399.304-.75.522-1.055.218-.305.469-.565.753-.779.283-.214.58-.389.89-.525.31-.135.624-.235.942-.299.317-.064.614-.096.889-.096h5.387c.512 0 .972.064 1.378.192.406.128.763.297 1.073.508.311.21.575.455.793.734.218.278.396.569.534.874a4.466 4.466 0 0 1 .402 1.8v3.973c0 .504-.065.958-.195 1.36a3.968 3.968 0 0 1-.517 1.061zm-15.94-.277a3.928 3.928 0 0 1-.862.904c-.329.248-.67.451-1.022.609-.352.158-.71.275-1.074.35a5.095 5.095 0 0 1-1.028.113H.138V13.25h11.518c.574 0 1.021-.165 1.338-.496.318-.331.477-.775.477-1.332 0-.271-.042-.519-.126-.745a1.61 1.61 0 0 0-.936-.971 2.019 2.019 0 0 0-.753-.135H4.789a5.421 5.421 0 0 1-1.562-.254 4.704 4.704 0 0 1-1.556-.818C1.192 8.123.794 7.63.477 7.02.159 6.411 0 5.666 0 4.786c0-.881.159-1.624.477-2.23A4.547 4.547 0 0 1 3.227.254 5.421 5.421 0 0 1 4.789 0h10.163v2.934H4.789c-.567 0-1.009.17-1.326.508-.318.339-.477.787-.477 1.344 0 .564.159 1.01.477 1.337.317.327.759.491 1.326.491h6.891c.321.007.662.05 1.022.13a5.216 5.216 0 0 1 2.09.993c.321.252.607.555.855.908.249.354.446.76.592 1.219.145.459.218.978.218 1.558 0 .579-.075 1.1-.224 1.563a4.607 4.607 0 0 1-.591 1.224z"
        />
        <path
          fill="#FF2601"
          fillRule="evenodd"
          d="M114.786 6.919v9.266h-3.02V6.919h-3.882V3.984h3.882V0h3.02v3.984H120v2.935h-5.214zm-9.009 3.73a3.946 3.946 0 0 1-1.275 1.01c-.525.271-1.162.406-1.912.406h-5.386V9.278h5.386c.406 0 .719-.123.941-.367.222-.245.333-.548.333-.909 0-.384-.124-.685-.373-.903a1.32 1.32 0 0 0-.901-.327h-5.386c-.406 0-.72.122-.942.367a1.3 1.3 0 0 0-.333.909v4.096c0 .391.124.696.373.915.249.218.557.327.924.327h5.364v2.799h-5.386c-.414 0-.86-.071-1.339-.215a3.89 3.89 0 0 1-2.36-1.946c-.275-.516-.413-1.142-.413-1.88V8.025c0-.406.073-.845.218-1.315.146-.47.381-.907.707-1.31.325-.402.75-.739 1.274-1.01.525-.27 1.162-.406 1.913-.406h5.386c.413 0 .859.072 1.338.215.478.143.922.374 1.332.694.409.319.752.737 1.027 1.253.276.515.414 1.141.414 1.879 0 .406-.073.844-.218 1.315-.146.47-.381.906-.706 1.309zM87.74 9.413c0-.384-.067-.728-.201-1.033a2.389 2.389 0 0 0-.545-.784c-.23-.218-.5-.386-.81-.502a2.823 2.823 0 0 0-1.005-.175h-5.225v9.266h-2.986V5.44a1.413 1.413 0 0 1 .436-1.033 1.539 1.539 0 0 1 1.068-.423h6.73c.376 0 .772.041 1.189.124.417.083.831.217 1.24.401.41.184.8.417 1.172.699.371.283.7.625.987 1.028.287.402.515.867.684 1.394.168.526.252 1.121.252 1.783v6.772H87.74V9.413z"
        />
      </svg>
    );
  } else if (name === 'one-question') {
    content = (
      <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29">
        <path
          fill="none"
          stroke="#424242"
          strokeWidth="2"
          d="M4 7.989h14a2 2 0 0 1 2 2v14.022a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.989a2 2 0 0 1 2-2zM6 15h10M6 20h10"
        />
        <path
          fill="#FFF"
          fillRule="evenodd"
          stroke="#424242"
          strokeWidth="2"
          d="M15 10H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h1.183A2.992 2.992 0 0 1 11 4a2.99 2.99 0 0 1 2.816 2H15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1z"
        />
        <path
          fill="#FFF"
          fillRule="evenodd"
          stroke="#424242"
          strokeWidth="2"
          d="M19.5 1a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15z"
        />
        <path
          fill="none"
          stroke="#424242"
          strokeWidth="2"
          d="M17.014 10.986l4.981-4.982M16.991 5.999l5.01 5.01"
        />
      </svg>
    );
  } else if (name === 'arrow-down') {
    content = (
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9">
        <path
          fill="none"
          stroke="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M8.997 2.008L5.498 5.996l-3.5-3.988"
        />
      </svg>
    );
  } else if (name === 'checkbox') {
    content = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 27 27"
        width={width || 27}
        height={height || 27}
      >
        <path
          fill="none"
          stroke="#EEE"
          strokeWidth="2"
          d="M13 1c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12C1 6.372 6.372 1 13 1z"
        />
      </svg>
    );
  } else if (name === 'checkbox-checked') {
    content = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 27 27"
        width={width || 27}
        height={height || 27}
      >
        <path
          fill="none"
          fillRule="evenodd"
          stroke="#4CBC56"
          strokeWidth="2"
          d="M13 1c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12C1 6.372 6.372 1 13 1z"
        />
        <path
          fill="none"
          fillRule="evenodd"
          stroke="#4CBC56"
          strokeWidth="2"
          d="M18.316 9.744l-6.468 5.894-4.165-3.795"
        />
      </svg>
    );
  } else if (name === 'checkbox-correct') {
    content = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 27 27"
        width={width || 27}
        height={height || 27}
      >
        <path
          fill="#4CBC56"
          fillRule="evenodd"
          stroke="#4CBC56"
          strokeWidth="2"
          d="M13 1c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12-6.628 0-12-5.373-12-12C1 6.372 6.372 1 13 1z"
        />
        <path
          fill="none"
          stroke="#FFF"
          strokeWidth="2"
          d="M18.316 9.736l-6.468 5.91-4.164-3.806"
        />
      </svg>
    );
  } else if (name === 'checkbox-wrong') {
    content = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 25 25"
        width={width || 25}
        height={height || 25}
      >
        <path
          fill="#FF2601"
          fillRule="evenodd"
          d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12C5.372 24 0 18.627 0 12S5.372 0 12 0z"
        />
        <path
          fill="none"
          stroke="#FFF"
          strokeWidth="2"
          d="M6.768 17.232L17.284 6.715M6.719 6.703L17.296 17.28"
        />
      </svg>
    );
  } else if (name === 'checkbox-unknown') {
    content = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={width || 24}
        height={height || 24}
      >
        <path
          d="M12,0 C18.627,0 24,5.373 24,12 C24,18.627 18.627,24 12,24 C5.372,24 0,18.627 0,12 C0,5.373 5.372,0 12,0 z"
          fill="#FFCD01"
        />
        <path
          d="M11.243,15.199 Q11.235,14.9 11.235,14.75 Q11.235,13.868 11.484,13.227 Q11.667,12.745 12.075,12.254 Q12.374,11.896 13.152,11.21 Q13.93,10.523 14.163,10.115 Q14.396,9.708 14.396,9.225 Q14.396,8.352 13.714,7.69 Q13.032,7.029 12.042,7.029 Q11.085,7.029 10.444,7.628 Q9.803,8.227 9.604,9.5 L8.065,9.317 Q8.273,7.611 9.3,6.704 Q10.328,5.797 12.017,5.797 Q13.805,5.797 14.87,6.771 Q15.935,7.744 15.935,9.125 Q15.935,9.924 15.561,10.598 Q15.187,11.272 14.097,12.237 Q13.364,12.886 13.14,13.194 Q12.915,13.502 12.807,13.901 Q12.699,14.301 12.682,15.199 z M11.151,18.203 L11.151,16.497 L12.857,16.497 L12.857,18.203 z"
          fill="#FFFFFF"
        />
      </svg>
    );
  } else if (name === 'exclamation-mark-circle') {
    content = (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 200 200"
        width={width || 24}
        height={height || 24}
      >
        <path
          fill="none"
          stroke="#000"
          strokeWidth="16"
          strokeLinecap="round"
          d="M89,9a81,81 0 1,0 2,0zm1,38v58m0,25v1"
        />
      </svg>
    );
  }

  if (content) {
    return <span className={`icon ${className}`}>{content}</span>;
  }
  return null;
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

Icon.defaultProps = {
  className: null,
  color: null,
  width: null,
  height: null,
};

export default withTheme(Icon);
